module.exports = __webpack_public_path__ + "static/img_1559-8eca4a07767f6e02812b9234af27226b.webp";